import { render, staticRenderFns } from "./sound_index.vue?vue&type=template&id=159cbf70&scoped=true"
import script from "./sound_index.vue?vue&type=script&lang=js"
export * from "./sound_index.vue?vue&type=script&lang=js"
import style0 from "./sound_index.vue?vue&type=style&index=0&id=159cbf70&prod&scoped=true&lang=css"
import style1 from "./sound_index.vue?vue&type=style&index=1&id=159cbf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cbf70",
  null
  
)

export default component.exports